/** Fashion is season-bounded; NOOS is continuous. React-free, so the server can use it too. */
export type CollectionKind = "fashion" | "noos"

export const kindOf = (c: { collectionType: string | null }): CollectionKind =>
  (c.collectionType ?? "").toLowerCase() === "noos" ? "noos" : "fashion"

/** Why a fashion plan's weeks are read-only; the weekly editor and `setDemandDatedOverrides` share it. */
export const FASHION_WEEKS_LOCKED_REASON =
  "Fashion demand follows the season curve, so weeks can't be edited."
